import { useHistory } from 'react-router-dom';
import { getGpAuthLoginToken, gpAuthLogout } from './gpAuthService';

export default function useAuthProvider() {
    const history = useHistory();

    const signinByRedirect = async () => {
        try {
            console.log('[authProvider] signinByRedirect() called - using GP Auth');
            // GP Auth handles the redirect internally
            await getGpAuthLoginToken('/index.html', 'en-US');
        }
        catch (error) {
            console.error('[authProvider] GP Auth login failed:', error);
            history.push('/login');
        }
    };

    const signoutFromProvider = async () => {
       try {
          await gpAuthLogout();
        } catch (error) {
            console.error('GP Auth logout failed:', error);
        }
    };

    return {
        signinByRedirect,
        signoutFromProvider,
    };
}
